import {useChildContext} from "root/Contexts/ChildContext";
import React, {useState} from "react";
import {
    childCarer, childEdPsych, childESW, childIRO, childSchool, childSocialWorker, formModes,
} from "root/Base/HookFormComponents/childDataFormHelpers";
import {useForm} from "react-hook-form";

import {SaveButton} from "root/Modals/SaveButton";
import {CancelButton} from "root/Modals/CancelButton";
import HookFormGroupChildPeople from "root/Base/HookFormComponents/ChildPeople/HookFormGroupChildPeople";
import {newChildModes} from "./CreateChild3";

const Page3 = ( { notify, mode }) =>
{
    const { child, isPost16 } = useChildContext() ;
    const [ buttonsDisabled, setButtonsDisabled ] = useState ( false ) ;

    const ChildPeopleFormFields = {
        ... childCarer(child),
        ... childSocialWorker(child),
        ... childIRO(child),
        ... childESW(child),
        ... childEdPsych(child),
        ... childSchool(child),
    }

    const {register, reset, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                ...ChildPeopleFormFields,
            }
        });

    const onSubmit = (data) =>
    {
        if ( mode === newChildModes.RETURNING )
        {
            notify( {
                fragment: data,
                stage: 4,
            });
        }
        else
        {
            notify( {
                fragment: data,
                stage: 4,
                action: 'submit'
            });
        }
    }

    const onClickSaveForm = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const onClickCancel = () =>
    {
        notify ({ stage: 1 });
    }


    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        formErrors: formErrors,
        readOnly: false,
        setValue: setValue,
        reset: reset
    }

    const buttonText = mode === newChildModes.RETURNING ? 'Restore Pupil' : 'Create Pupil' ;

    const formMode = mode === newChildModes.NEW ? formModes.CREATE : formModes.EDIT ;

    return (
        <form className='' onSubmit={handleSubmit(onSubmit)}>

            <HookFormGroupChildPeople {...controlProps} formMode={formMode} isPost16={isPost16}/>

            <div className="button-row top-margin">
                <SaveButton disabled={buttonsDisabled} onClick={onClickSaveForm} kay={'sb'}>{buttonText}</SaveButton>
                <CancelButton disabled={buttonsDisabled} onClick={onClickCancel} key={'cb'}>Cancel</CancelButton>
            </div>
        </form>
    )
}

export default Page3 ;